import "./index.css";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Card, Spin } from "antd";
import MenuLayout from "../../../components/Menu";
import Loading from "../../../components/Loading";
import EnhancedLoading from "../../../components/Loading/EnhancedLoading";
import { useUser } from "../../../contexts/UserContext";

const { Title } = Typography;

const ModifyUsersPage = () => {
  const navigate = useNavigate();
  const { userProfile, isAdmin, loading, retryCount } = useUser();

  useEffect(() => {
    if (!loading && !isAdmin) {
      // User doesn't have admin role, redirect to search page
      navigate("/search");
    }
  }, [loading, isAdmin, navigate]);

  if (!loading && !isAdmin) {
    // Don't render anything while redirecting
    return null;
  }

  return (
    <MenuLayout>
      <Spin 
        tip={retryCount > 0 ? `正在重试... (第 ${retryCount} 次尝试)` : "加载中..."} 
        indicator={<Loading />} 
        spinning={loading}
      >
        <div className="admin-page">
          <Card className="admin-card">
            <Title level={2}>修改用户</Title>
            <p>在此页面修改现有用户信息。</p>
            {/* User modification interface will be added here later */}
          </Card>
        </div>
      </Spin>
    </MenuLayout>
  );
};

export default ModifyUsersPage; 